import styles from "./EmailInput.module.css"
import React from 'react';
import { AtSign } from 'lucide-react';
import { useTranslation } from "react-i18next";
/**
* Props for the EmailInput component.
*/ 
interface EmailInputProps {
    text?: string, // Input label
    onChange?: (value: string) => void, // Change event handler
    email?: string // Current email
}
/**
* An email input component with optional label.
*
* @param props EmailInput props
* @param {string} props.text - Input label
* @param {(value: string) => void} props.onChange - Change event handler
* @param {string} props.email - Current email
* @returns TSX.Element
*/
const EmailInput: React.FC<EmailInputProps> = ({ text = "" , onChange, email}) => {
    const { t } = useTranslation(); // Translation
    if (text === "") text = t("inputs.email"); // Email placeholder
    
    return(
        <>
            <div className={styles.EmailInputBlock}>
                <div className={styles.EmailInputCenter}>
                    <div className={styles.EmailInputIcon}>
                        <AtSign />
                    </div>
                    <input type="email" className={styles.EmailInputField}
                    onChange={(e)=>onChange && onChange(e.target.value)}
                    value={email}
                    />
                </div>
                <div className={styles.EmailInputLabel}><p>{text}</p></div>
                <div className={styles.EmailInputTooltip}></div>
            </div>
        </>
    )
};

export default EmailInput;